export default __webpack_public_path__ + "static/media/8E5CD67A-5F8D-4E65-8BBF-2049503FA1B4_1_105_c.4d0972ee.jpg";